<template>
  <div class="base-carddraw">
    <div class="card-list">
      <div
        v-for="index in mValue.num"
        :class="{ item: true, shake: active == index }"
        :key="index"
        @click="onStart(index)"
      >
        <slot name="item" :item="mValue.bg || defaultBg"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseRedpack',
  props: {
    draw: {
      type: Object,
      default: () => {}
    },
    turnsTime: {
      // 转动需要持续的时间(秒)
      default: 3
    },
    viewStatus: {
      type: Number
    }
  },
  data() {
    return {
      mValue: undefined,
      listValue: [],
      defaultBg:
        'https://cdn-tx-admin-test.3kwan.com/2023/07/13/3e884759444a0e3d79ba11b6c334d996.png',
      active: -1
    };
  },
  components: {},
  computed: {
    state() {
      return this.$store.state;
    }
  },
  watch: {
    draw: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.mValue = newVal;
        if (this.viewStatus != 2) {
          this.state.isShowDialogRedEffect = newVal.aniSwitch;
        }
      }
    }
  },
  methods: {
    onStart(i) {
      this.active = i;
      setTimeout(() => {
        this.active = -1;
        this.$emit('start-turns');
      }, 1000);
    },
    runAni() {
      this.$store.commit('OPEN_DIALOG', 'RedEffect');
      const turnsTime = this.turnsTime;
      setTimeout(() => {
        this.$store.commit('CLOSE_DIALOG', 'RedEffect');
      }, turnsTime * 1000);
      setTimeout(() => {
        this.$emit('end-turns');
      }, turnsTime * 1000 + 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-list {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  .item {
    flex: 0 0 31%;
    margin-top: 20px;
  }
  img {
    display: block;
    width: 100%;
  }
}
</style>
<style>
.shake {
  animation: shake 1s linear;
}
@keyframes shake {
  70%,
  80% {
    transform: rotate(10deg);
  }
  75% {
    transform: rotate(-10deg);
  }

  65%,
  85% {
    transform: rotate(0);
  }
}
</style>
